<template>
  <Page>
    <PageContent>
      <SignatureSettingsContext>
        <SignatureSettings />
      </SignatureSettingsContext>
    </PageContent>
  </Page>
</template>

<script setup lang="ts">
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import SignatureSettings from '@/components/deepSign/signature/SignatureSettings.vue'
import SignatureSettingsContext from '@/components/deepSign/signature/SignatureSettingsContext.vue'
import Page from '@/components/page/Page.vue'
import PageContent from '@/components/page/PageContent.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepsign.settings',
  },
})

const { roles, permissions } = useAuthorizationContext()
const { selectedOrganization, isPersonal } = useAccountMembershipsContext()

usePageAccess(
  computed(
    () =>
      isPersonal(selectedOrganization.value) ||
      !permissions.canReadOrganizationMenu ||
      !permissions.canManageSignatureSettings ||
      !roles.isOwner,
  ),
)
</script>
